import { render, staticRenderFns } from "./鉴证书.vue?vue&type=template&id=2264c76d&scoped=true"
import script from "./鉴证书.vue?vue&type=script&lang=js"
export * from "./鉴证书.vue?vue&type=script&lang=js"
import style0 from "./鉴证书.vue?vue&type=style&index=0&id=2264c76d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2264c76d",
  null
  
)

export default component.exports